/* CJ Sleeper Quiz v7 (cj-home-fyf). Steps: 0 intro, 1-4 questions, 5 match reveal, 6 builder.
   Each answer carries fabric points (data-p); ties go NightCool, then DayBasics, then BambooSoft. The stepper is the
   sleep profile: a done step is tappable to change that answer. Every step change aligns the stage under the sticky
   header and animates the panel height, so nothing jumps or sits cut under the header.
   Builder: fetches /products/<handle>.js on demand, picks colour, size and any other option, adds the exact variant,
   then opens UpCart (same add route as cj-rec-quick-add). */
(function () {
  if (window.CJ_FYF7) return; window.CJ_FYF7 = 1;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* on the myshopify preview address calls redirect to www and die cross-origin; _fd=0 keeps them on the preview host */
  var ONMS = /\.myshopify\.com$/i.test(location.hostname);
  function U(p) { var u = ROOT + p; return ONMS ? u + (u.indexOf('?') > -1 ? '&' : '?') + '_fd=0' : u; }
  var ORDER = ['nc', 'db', 'bb'], QS = ['temp', 'feel', 'style', 'wear'];
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HOVER = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  function money(c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : String(d)); }
  function sized(src, w) { if (!src) return ''; src = src.replace(/^\/\//, 'https://'); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function isCart(r) { var ct = (r && r.headers && r.headers.get && r.headers.get('content-type')) || ''; return /json|javascript/i.test(ct); }
  function postForm(id) {
    var f = document.createElement('form'); f.method = 'post'; f.action = U('cart/add'); f.style.display = 'none';
    [['id', id], ['quantity', 1]].forEach(function (p) { var i = document.createElement('input'); i.type = 'hidden'; i.name = p[0]; i.value = String(p[1]); f.appendChild(i); });
    document.body.appendChild(f); HTMLFormElement.prototype.submit.call(f);
  }
  var cache = {};
  function getProduct(h) {
    if (!cache[h]) cache[h] = fetch(U('products/' + h + '.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok || !isCart(r)) throw new Error('product'); return r.json(); })
      .catch(function (e) { cache[h] = null; throw e; });
    return cache[h];
  }
  /* bottom edge of whatever is stuck to the top of the window (announcement bar, sticky header) */
  function headerBottom() {
    var y = 0, x = Math.round(window.innerWidth / 2);
    for (var n = 0; n < 6; n++) {
      var e = document.elementFromPoint(x, y + 2), hit = null;
      while (e && e !== document.body && e !== document.documentElement) {
        var p = getComputedStyle(e).position;
        if (p === 'fixed' || p === 'sticky') { hit = e; }
        e = e.parentElement;
      }
      if (!hit) break;
      var b = hit.getBoundingClientRect().bottom;
      if (b <= y + 2 || b > window.innerHeight * 0.5) break;
      y = b;
    }
    return y;
  }
  /* arrow keys move within a row of radios / tabs */
  function roving(row, sel) {
    row.addEventListener('keydown', function (e) {
      var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!d) return;
      var items = [].slice.call(row.querySelectorAll(sel)).filter(function (x) { return !x.hidden; }), i = items.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault(); items[(i + d + items.length) % items.length].focus();
    });
  }

  function quiz(root) {
    var steps = [].slice.call(root.querySelectorAll('.fyf-step'));
    var stage = root.querySelector('[data-fyf-stage]'), panel = root.querySelector('[data-fyf-panel]');
    var pics = root.querySelector('[data-fyf-pics]'), prodPic = root.querySelector('[data-pic=product]'), thumbs = root.querySelector('[data-fyf-thumbs]');
    var segs = [].slice.call(root.querySelectorAll('.fyf__steps button'));
    var answers = {}, step = 0, fab = null, hTimer = null, peeking = false;

    function showPic(key) {
      if (!pics.querySelector('[data-pic="' + key + '"]')) key = 'intro';
      [].forEach.call(pics.querySelectorAll('img'), function (i) { i.classList.toggle('is-on', i.getAttribute('data-pic') === key); });
    }
    function scores() {
      var t = { nc: 0, bb: 0, db: 0 };
      Object.keys(answers).forEach(function (k) { var p = answers[k].p || {}; Object.keys(p).forEach(function (f) { t[f] = (t[f] || 0) + p[f]; }); });
      return t;
    }
    function leader(t) { var best = null; ORDER.forEach(function (f) { if (best === null || t[f] > t[best]) best = f; }); return best; }
    function restPic() {
      if (step === 0) return showPic('intro');
      if (step >= 5) return showPic(step === 6 && prodPic.src ? 'product' : fab);
      var t = scores(), lead = leader(t);
      showPic(t[lead] > 0 ? lead : 'intro');
    }
    function meters() {
      var t = scores(), max = Math.max(t.nc, t.bb, t.db, 1), lead = leader(t), any = Object.keys(answers).length > 0;
      root.classList.toggle('has-answers', any);
      [].forEach.call(root.querySelectorAll('.fyf-m'), function (m) {
        var f = m.getAttribute('data-m');
        m.querySelector('i').style.width = (any ? Math.max(5, Math.round(t[f] / max * 100)) : 0) + '%';
        m.classList.toggle('is-lead', any && f === lead && t[f] > 0);
      });
    }
    function stepper(fresh) {
      segs.forEach(function (b) {
        var n = +b.getAttribute('data-go'), k = b.getAttribute('data-a'), li = b.parentNode, a = b.querySelector('.fyf__steps-a');
        var done = k === 'fab' ? !!fab : !!answers[k];
        var cur = k === 'fab' ? step >= 5 : step === n;
        var txt = k === 'fab' ? (fab ? (root.querySelector('[data-res="' + fab + '"]').getAttribute('data-name') || '') : '') : (answers[k] ? answers[k].v : '');
        if (a.textContent !== txt) { a.textContent = txt; if (fresh && txt) { li.classList.remove('is-new'); void li.offsetWidth; li.classList.add('is-new'); } }
        li.classList.toggle('is-done', done && !cur);
        li.classList.toggle('is-cur', cur);
        b.disabled = cur || !(done || (k !== 'fab' && step >= 5));
        b.setAttribute('aria-label', b.querySelector('.fyf__steps-l').textContent + (txt ? ': ' + txt + '. Change' : ''));
      });
    }
    function target(n) {
      if (n === 5) return root.querySelector('[data-res="' + fab + '"]');
      if (n === 6) return root.querySelector('[data-build="' + fab + '"]');
      return steps.filter(function (s) { return +s.getAttribute('data-s') === n && !s.hasAttribute('data-res') && !s.hasAttribute('data-build'); })[0];
    }
    /* put the stage right under the sticky header whenever it is cut by it or has drifted down the window */
    function align() {
      var hb = headerBottom(), r = stage.getBoundingClientRect(), narrow = window.innerWidth < 900;
      var want = hb + (narrow ? 10 : window.innerHeight < 800 ? 4 : 16);
      var cut = r.top < want - 4, low = narrow && r.top > want + 40;
      var overflow = r.bottom > window.innerHeight - 6;
      if (cut || low || overflow) window.scrollTo({ top: window.pageYOffset + r.top - want, behavior: REDUCED ? 'auto' : 'smooth' });
    }
    function go(n, back, quiet) {
      var el = target(n); if (!el) return;
      var out = steps.filter(function (s) { return !s.hidden; })[0];
      if (out === el) return;
      var h0 = panel.offsetHeight;
      if (out) { out.hidden = true; out.classList.remove('is-in', 'is-back'); }
      step = n; root.setAttribute('data-step', String(n));
      el.hidden = false;
      if (!REDUCED) el.classList.add(back ? 'is-back' : 'is-in');
      stepper(); restPic();
      /* glide the panel between the two heights instead of jumping */
      panel.style.height = '';
      var h1 = panel.offsetHeight;
      if (!REDUCED && Math.abs(h1 - h0) > 6) {
        clearTimeout(hTimer);
        panel.style.height = h0 + 'px'; void panel.offsetHeight;
        panel.style.transition = 'height .45s cubic-bezier(.2,.8,.2,1)'; panel.style.height = h1 + 'px';
        hTimer = setTimeout(function () { panel.style.transition = ''; panel.style.height = ''; }, 480);
      }
      var h = el.querySelector('.fyf-step__q, .fyf-res__persona');
      if (h && !quiet) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (x) {} }
      if (!quiet) setTimeout(align, REDUCED ? 0 : 60);
    }

    /* ---------- intro ---------- */
    root.querySelector('[data-fyf-start]').addEventListener('click', function () { go(1); });
    [].forEach.call(root.querySelectorAll('[data-fyf-skip]'), function (b) {
      var k = b.getAttribute('data-fyf-skip');
      b.addEventListener('click', function () { answers = {}; clearTiles(); fab = k; root.setAttribute('data-fab', fab); meters(); note(); peek(); go(5); });
      if (HOVER) { b.addEventListener('mouseenter', function () { if (step === 0) showPic(k); }); b.addEventListener('mouseleave', function () { if (step === 0) showPic('intro'); }); }
    });

    /* ---------- questions ---------- */
    function clearTiles() { [].forEach.call(root.querySelectorAll('.fyf-o'), function (o) { o.setAttribute('aria-pressed', 'false'); }); }
    function note() {
      var res = root.querySelector('[data-res="' + fab + '"]'), n = res && res.querySelector('[data-note-when]');
      if (n) n.hidden = !(answers.temp && n.getAttribute('data-note-when') === answers.temp.v);
    }
    /* the reveal previews the pieces picked for her; tapping one opens the builder on it */
    function peek() {
      var res = root.querySelector('[data-res="' + fab + '"]'), bld = root.querySelector('[data-build="' + fab + '"]');
      var box = res && res.querySelector('[data-fyf-peek]'); if (!box || !bld) return;
      var style = (answers.style && answers.style.style) || 'set', row = box.querySelector('.fyf-res__peek-row');
      var groups = [].slice.call(bld.querySelectorAll('.fyf-picks'));
      var grp = groups.filter(function (g) { return g.getAttribute('data-style') === style && g.children.length; })[0] || groups.filter(function (g) { return g.children.length; })[0];
      row.innerHTML = ''; box.hidden = !grp || grp.children.length < 2; if (box.hidden) return;
      [].forEach.call(grp.children, function (pk, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'fyf-peek'; b.style.setProperty('--i', i);
        var im = document.createElement('img'), src = pk.querySelector('img'); im.alt = ''; if (src) im.src = src.currentSrc || src.src; b.appendChild(im);
        var t = document.createElement('span'); t.textContent = pk.querySelector('.fyf-pick__t').textContent; b.appendChild(t);
        b.addEventListener('click', function () { go(6); builder(bld, grp.getAttribute('data-style')); if (pk.getAttribute('aria-checked') !== 'true') pk.click(); });
        if (HOVER) {
          b.addEventListener('mouseenter', function () { if (step === 5) { peeking = true; setPic(pk.getAttribute('data-img'), true); } });
          b.addEventListener('mouseleave', function () { peeking = false; if (step === 5) showPic(fab); });
        }
        row.appendChild(b);
      });
    }
    function finish() {
      fab = leader(scores());
      if (!root.querySelector('[data-res="' + fab + '"]')) fab = ORDER.filter(function (f) { return root.querySelector('[data-res="' + f + '"]'); })[0];
      root.setAttribute('data-fab', fab); note(); peek(); go(5);
    }
    steps.forEach(function (s) {
      var k = s.getAttribute('data-k'); if (!k) return;
      var opts = [].slice.call(s.querySelectorAll('.fyf-o'));
      roving(s.querySelector('.fyf-opts'), '.fyf-o');
      opts.forEach(function (o) {
        o.setAttribute('aria-pressed', 'false');
        var p = {}; try { p = JSON.parse(o.getAttribute('data-p') || '{}'); } catch (x) {}
        /* hovering an answer previews the fabric it leans to */
        var lean = null; ORDER.forEach(function (f) { if (p[f] && (lean === null || p[f] > p[lean])) lean = f; });
        if (HOVER && lean) { o.addEventListener('mouseenter', function () { if (step < 5) showPic(lean); }); o.addEventListener('mouseleave', function () { if (step < 5) restPic(); }); }
        o.addEventListener('click', function () {
          if (s.__lock) return; s.__lock = true;
          opts.forEach(function (x) { x.setAttribute('aria-pressed', x === o ? 'true' : 'false'); });
          answers[k] = { v: o.getAttribute('data-v'), p: p, style: o.getAttribute('data-style') };
          meters(); stepper(true);
          setTimeout(function () {
            s.__lock = false;
            var next = QS.filter(function (q) { return !answers[q]; })[0];
            if (next) go(QS.indexOf(next) + 1); else finish();
          }, REDUCED ? 0 : 430);
        });
      });
    });
    [].forEach.call(root.querySelectorAll('[data-fyf-back]'), function (b) { b.addEventListener('click', function () { go(step > 1 ? step - 1 : 0, true); }); });
    [].forEach.call(root.querySelectorAll('[data-fyf-restart]'), function (b) {
      b.addEventListener('click', function () { answers = {}; fab = null; root.removeAttribute('data-fab'); clearTiles(); meters(); go(1, true); });
    });
    segs.forEach(function (b) {
      b.addEventListener('click', function () { if (b.disabled) return; var n = +b.getAttribute('data-go'); go(n, n < step); });
    });
    [].forEach.call(root.querySelectorAll('[data-fyf-build]'), function (b) {
      b.addEventListener('click', function () {
        var bld = root.querySelector('[data-build="' + fab + '"]');
        go(6);
        builder(bld, (bld.__st && bld.__st.style) || (answers.style && answers.style.style) || 'set');
      });
    });

    /* ---------- photo: zoom follows the cursor on the builder step ---------- */
    if (HOVER) {
      pics.addEventListener('mousemove', function (e) {
        if (step !== 6 || window.innerWidth < 900) return;
        var r = pics.getBoundingClientRect();
        prodPic.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
        prodPic.classList.add('is-zoom');
      });
      pics.addEventListener('mouseleave', function () { prodPic.classList.remove('is-zoom'); });
    }
    function setPic(src, keepThumb) {
      if (!src) return;
      if (prodPic.getAttribute('data-cur') === src && prodPic.src) { if (step === 6 || peeking) showPic('product'); }
      else {
        prodPic.setAttribute('data-cur', src); prodPic.classList.add('is-swap');
        var n = new Image();
        n.onload = n.onerror = function () {
          if (prodPic.getAttribute('data-cur') !== src) return;
          prodPic.src = src; prodPic.hidden = false; prodPic.classList.remove('is-swap');
          if (step === 6 || peeking) showPic('product');
        };
        n.src = src;
      }
      if (!keepThumb) { var base = src.split('?')[0]; [].forEach.call(thumbs.children, function (t) { t.setAttribute('aria-current', t.getAttribute('data-src').split('?')[0] === base ? 'true' : 'false'); }); }
    }

    /* ---------- builder ---------- */
    function builder(res, style) {
      var st = res.__st || (res.__st = { token: 0 });
      var groups = [].slice.call(res.querySelectorAll('.fyf-picks'));
      var tabsBox = res.querySelector('.fyf-tabs'), tabs = [].slice.call(tabsBox.querySelectorAll('[role=tab]'));
      var grp = groups.filter(function (g) { return g.getAttribute('data-style') === style && g.children.length; })[0] || groups.filter(function (g) { return g.children.length; })[0];
      if (!grp) return;
      st.style = grp.getAttribute('data-style');
      groups.forEach(function (g) { g.hidden = g !== grp; });
      /* the style tabs only show when the fabric really has different pieces per style */
      var handles = {}; groups.forEach(function (g) { [].forEach.call(g.children, function (p) { handles[p.getAttribute('data-h')] = 1; }); });
      tabsBox.hidden = Object.keys(handles).length < 2;
      tabs.forEach(function (t) {
        var g = groups.filter(function (x) { return x.getAttribute('data-style') === t.getAttribute('data-style'); })[0];
        t.hidden = !(g && g.children.length);
        t.setAttribute('aria-selected', t.getAttribute('data-style') === st.style ? 'true' : 'false');
        if (!t.__wired) { t.__wired = 1; t.addEventListener('click', function () { if (t.getAttribute('aria-selected') !== 'true') builder(res, t.getAttribute('data-style')); }); }
      });
      if (!tabsBox.__wired) { tabsBox.__wired = 1; roving(tabsBox, '[role=tab]'); }

      var picks = [].slice.call(grp.querySelectorAll('.fyf-pick'));
      var optsBox = res.querySelector('[data-fyf-opts]'), add = res.querySelector('[data-fyf-add]'), addL = res.querySelector('[data-fyf-add-l]');
      var nameEl = res.querySelector('[data-fyf-name]'), priceEl = res.querySelector('[data-fyf-price]'), rEl = res.querySelector('[data-fyf-r]'), msg = res.querySelector('[data-fyf-msg]');

      function match(o) { for (var i = 0; i < st.P.variants.length; i++) { var v = st.P.variants[i], ok = true; for (var j = 0; j < o.length; j++) { if (o[j] != null && v.options[j] !== o[j]) { ok = false; break; } } if (ok) return v; } return null; }
      function avail(i, val) { var t = st.sel.slice(); t[i] = val; return st.P.variants.some(function (v) { return v.available && t.every(function (x, j) { return x == null || v.options[j] === x; }); }); }
      function current() { return st.sel.every(function (x) { return x != null; }) ? match(st.sel) : null; }
      function partial(sel) { return st.P.variants.filter(function (x) { return sel.every(function (s, j) { return s == null || x.options[j] === s; }); })[0] || st.P.variants[0]; }
      function vimg(v) { return sized((v && v.featured_image && v.featured_image.src) || st.P.featured_image, 1000); }
      function paint() {
        var P = st.P, sel = st.sel;
        [].forEach.call(optsBox.querySelectorAll('[data-i]'), function (b) {
          var i = +b.getAttribute('data-i'), val = b.getAttribute('data-v'), on = sel[i] === val;
          b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on || (sel[i] == null && !b.previousElementSibling) ? 0 : -1;
          b.classList.toggle('is-out', !avail(i, val));
        });
        [].forEach.call(optsBox.querySelectorAll('[data-oi]'), function (em) { em.textContent = sel[+em.getAttribute('data-oi')] || ''; });
        var v = current(), pv = v || partial(sel);
        priceEl.innerHTML = '<b>' + money(pv.price) + '</b>' + (pv.compare_at_price > pv.price ? '<s>' + money(pv.compare_at_price) + '</s>' : '');
        var missing = P.options.filter(function (o, i) { return sel[i] == null; })[0];
        add.disabled = false; add.classList.remove('is-wait');
        if (missing) { add.classList.add('is-wait'); addL.textContent = 'Choose a ' + missing.name.toLowerCase(); }
        else if (!v || !v.available) { add.classList.add('is-wait'); addL.textContent = 'Sold out, try another size'; }
        else { addL.textContent = 'Add to cart · ' + money(v.price); }
        setPic(vimg(pv));
      }
      function render() {
        var P = st.P, num = 2;
        optsBox.innerHTML = ''; optsBox.classList.remove('is-loading');
        P.options.forEach(function (o, i) {
          var name = (o.name || '').toLowerCase(), isColor = name === 'color' || name === 'colour';
          if (o.values.length < 2) { st.sel[i] = o.values[0]; return; }
          var wrap = document.createElement('div'); wrap.className = 'fyf-opt';
          var h = document.createElement('p'); h.className = 'fyf-opt__h';
          var nb = document.createElement('span'); nb.textContent = String(num++); h.appendChild(nb);
          h.appendChild(document.createTextNode(o.name + ' '));
          var em = document.createElement('em'); em.setAttribute('data-oi', String(i)); h.appendChild(em);
          wrap.appendChild(h);
          var row = document.createElement('div'); row.className = 'fyf-opt__row'; row.setAttribute('role', 'radiogroup'); row.setAttribute('aria-label', o.name);
          roving(row, '[data-i]');
          o.values.forEach(function (val) {
            var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'radio');
            b.setAttribute('data-i', String(i)); b.setAttribute('data-v', val);
            if (isColor) {
              b.className = 'fyf-sw'; b.style.setProperty('--c', st.sw[val] || '#ccc'); b.setAttribute('aria-label', val); b.title = val;
              /* hovering a colour previews it on the photo before she commits */
              if (HOVER) {
                b.addEventListener('mouseenter', function () { var t = st.sel.slice(); t[i] = val; em.textContent = val; setPic(vimg(partial(t)), true); });
                b.addEventListener('mouseleave', function () { paint(); });
              }
            } else { b.className = 'fyf-chip'; b.textContent = val; }
            b.addEventListener('click', function () { st.sel[i] = val; msg.textContent = ''; paint(); });
            row.appendChild(b);
          });
          wrap.appendChild(row); optsBox.appendChild(wrap);
        });
        paint();
      }
      function buildThumbs(P) {
        thumbs.innerHTML = '';
        (P.images || []).slice(0, 5).forEach(function (u, k) {
          var full = sized(u, 1000), t = document.createElement('button');
          t.type = 'button'; t.className = 'fyf-th'; t.setAttribute('data-src', full); t.setAttribute('aria-label', 'Photo ' + (k + 1));
          var im = document.createElement('img'); im.src = sized(u, 160); im.alt = ''; t.appendChild(im);
          t.addEventListener('click', function () { setPic(full); });
          if (HOVER) t.addEventListener('mouseenter', function () { setPic(full); });
          thumbs.appendChild(t);
        });
      }
      function choose(btn) {
        picks.forEach(function (b) { var on = b === btn; b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
        nameEl.textContent = btn.getAttribute('data-t'); nameEl.href = btn.getAttribute('data-url');
        var r = (btn.getAttribute('data-r') || '').split('|');
        rEl.textContent = r[0] ? r[0] + ' (' + r[1] + ' reviews)' : '';
        priceEl.innerHTML = '<b>' + btn.getAttribute('data-price') + '</b>' + (btn.getAttribute('data-was') ? '<s>' + btn.getAttribute('data-was') + '</s>' : '');
        st.sw = {}; (btn.getAttribute('data-sw') || '').split('||').forEach(function (pr) { var k = pr.split('::'); if (k[0]) st.sw[k[0]] = k[1]; });
        setPic(btn.getAttribute('data-img'));
        optsBox.classList.add('is-loading'); thumbs.innerHTML = ''; st.P = null; st.url = null;
        add.disabled = true; add.classList.add('is-wait'); addL.textContent = 'Loading options'; msg.textContent = '';
        var my = ++st.token;
        getProduct(btn.getAttribute('data-h')).then(function (p) {
          if (my !== st.token) return;
          var keep = st.keep || {};
          st.P = p; buildThumbs(p);
          var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
          /* carry her colour and size across pieces when the new piece has them */
          st.sel = p.options.map(function (o, i) {
            var n = (o.name || '').toLowerCase();
            if (keep[n] && o.values.indexOf(keep[n]) > -1) return keep[n];
            return n === 'size' ? null : first.options[i];
          });
          render();
        }).catch(function () {
          if (my !== st.token) return;
          optsBox.innerHTML = ''; optsBox.classList.remove('is-loading');
          st.url = btn.getAttribute('data-url'); addL.textContent = 'View this piece'; add.disabled = false; add.classList.remove('is-wait');
        });
      }
      function remember() {
        if (!st.P) return; st.keep = {};
        st.P.options.forEach(function (o, i) { if (st.sel[i] != null) st.keep[(o.name || '').toLowerCase()] = st.sel[i]; });
      }
      if (!grp.__wired) {
        grp.__wired = 1; roving(grp, '.fyf-pick');
        picks.forEach(function (b) { b.addEventListener('click', function () { if (b.getAttribute('aria-checked') !== 'true') { remember(); choose(b); } }); });
      }
      if (!add.__wired) {
        add.__wired = 1;
        add.addEventListener('click', function () {
          if (st.url && !st.P) { location.href = st.url; return; }
          var v = st.P ? current() : null;
          if (!v || !v.available) {
            /* not ready: point at what is missing instead of doing nothing */
            optsBox.classList.remove('is-nudge'); void optsBox.offsetWidth; optsBox.classList.add('is-nudge');
            var f = optsBox.querySelector('.fyf-opt:last-child [data-i]:not(.is-out)'); if (f) try { f.focus({ preventScroll: true }); } catch (x) {}
            return;
          }
          if (add.getAttribute('aria-busy') === 'true') return;
          add.setAttribute('aria-busy', 'true'); addL.textContent = 'Adding';
          var added = false, req;
          try { req = fetch(U('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) }); }
          catch (x) { req = Promise.reject(x); }
          req.then(function (r) { if (!isCart(r)) throw new Error('not a cart answer'); return r.json().then(function (d) { if (!r.ok || d.status) throw d; return d; }); })
            .then(function () {
              added = true; add.removeAttribute('aria-busy'); add.classList.add('is-done');
              addL.textContent = 'Added ✓ ' + v.title;
              if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (x) {} }
              if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); } catch (x) {} }
              try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (x) {}
              setTimeout(function () { add.classList.remove('is-done'); if (st.P) paint(); }, 2600);
            })
            .catch(function (x) {
              if (added) return; add.removeAttribute('aria-busy'); if (st.P) paint();
              if (!x || !x.status) { postForm(v.id); return; }
              msg.textContent = x.description || 'We could not add that one. Please try another size.';
            });
        });
      }
      remember();
      choose(grp.querySelector('[aria-checked=true]') || picks[0]);
    }

    meters(); stepper();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-fyf]'), function (root) { if (!root.__fyf) { root.__fyf = 1; quiz(root); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
